import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight, Search } from "lucide-react";
import Seo from "../components/Seo";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found | 518 Courier"
        description="The page you're looking for doesn't exist. Head back home or contact dispatch at 518-954-4701."
        noindex
      />
      <section className="min-h-[70vh] flex items-center justify-center bg-slate-50">
        <div className="container-518 text-center">
          <div className="font-display text-8xl md:text-9xl font-extrabold text-[#0f2847] leading-none">
            4<span className="text-[#f59321]">0</span>4
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#0f2847] mt-4">
            This route doesn't exist.
          </h1>
          <p className="mt-3 text-slate-600 max-w-md mx-auto">
            The page you're looking for has moved or was never here. Let's get you back on the road.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/">
              <Button className="bg-[#f59321] hover:bg-[#e07f10] text-white rounded-full h-12 px-6 font-semibold btn-lift">
                <Home className="w-4 h-4 mr-2" />
                Back to home
              </Button>
            </Link>
            <Link to="/services">
              <Button variant="outline" className="rounded-full h-12 px-6 font-semibold border-2">
                See our services
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/tracking">
              <Button variant="outline" className="rounded-full h-12 px-6 font-semibold border-2">
                <Search className="w-4 h-4 mr-2" />
                Track an order
              </Button>
            </Link>
          </div>
          <p className="mt-8 text-sm text-slate-500">
            Need help now? Call dispatch at{" "}
            <a href="tel:5189544701" className="text-[#f59321] font-semibold hover:underline">
              518-954-4701
            </a>
          </p>
        </div>
      </section>
    </>
  );
}
